import { isNull } from "./validateBase"

/**
 * 本地存储封装
 * created by 李智惠 2021-11-4
 */
const session = {
    get(key) {
        try {
            return JSON.parse(window.sessionStorage.getItem(key))
        } catch (error) {
            return window.sessionStorage.getItem(key)
        }

    },
    set(key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value))
    },
    remove(key) {
        window.sessionStorage.removeItem(key)
    },
    clear() {
        window.sessionStorage.clear()
    }
}

export default session;